export function resolveProjectRows(res) {
  if (Array.isArray(res)) return res
  if (Array.isArray(res?.data)) return res.data
  if (Array.isArray(res?.list)) return res.list
  if (Array.isArray(res?.records)) return res.records
  return []
}

export function normalizeProjectOptions(res) {
  return resolveProjectRows(res)
    .map(item => ({
      text: (item.name || item.projectName || "-").trim(),
      value: item.id ?? item.projectId
    }))
    .filter(x => x.value !== null && x.value !== undefined && x.value !== "")
}

export function formatProjectName(row, options = {}) {
  if (!row || typeof row !== "object") return "-"
  const deposit = !!options.deposit
  const name = (deposit ? row.depositProjectName : row.projectName) || ""
  if (String(name).trim()) return String(name).trim()
  return "-"
}

export function normalizeProjectDepartmentIds(row) {
  if (!row || typeof row !== "object") return []
  const raw =
    row.departmentIds ??
    row.departmentIdList ??
    row.topDepartmentIds ??
    row.topDepartmentIdList ??
    row.topDepartmentList ??
    row.departmentList ??
    []
  if (Array.isArray(raw)) {
    return raw
      .map(item => {
        if (item === null || item === undefined || item === "") return null
        if (typeof item === "object") return item.weId ?? item.id ?? item.topDepartmentId ?? item.departmentId
        return item
      })
      .filter(x => x !== null && x !== undefined && x !== "")
      .map(x => String(x))
  }
  if (typeof raw === "string" && raw.trim()) {
    return raw
      .split(/[,，、]/)
      .map(x => x.trim())
      .filter(Boolean)
  }
  return []
}

export function formatProjectDepartmentNames(row, options = []) {
  if (!row || typeof row !== "object") return "-"
  const nameFields = [row.topDepartmentNames, row.departmentNames, row.topDepartmentName]
  for (const field of nameFields) {
    if (Array.isArray(field) && field.length) {
      const names = field.map(x => String(x || "").trim()).filter(Boolean)
      if (names.length) return names.join("、")
    }
    if (typeof field === "string" && field.trim()) return field.trim()
  }
  const list = row.topDepartmentList || row.departmentList
  if (Array.isArray(list) && list.length) {
    const names = list
      .map(item => {
        if (typeof item === "string") return item.trim()
        if (item && typeof item === "object") {
          return (item.weName || item.name || item.topDepartmentName || item.departmentName || "").trim()
        }
        return ""
      })
      .filter(Boolean)
    if (names.length) return names.join("、")
  }
  const ids = normalizeProjectDepartmentIds(row)
  if (!ids.length) return "-"
  if (!Array.isArray(options) || !options.length) return ids.join("、")
  const names = ids
    .map(id => {
      const hit = options.find(x => String(x.value) === String(id))
      return hit ? hit.text || hit.label : String(id)
    })
    .filter(Boolean)
  return names.length ? names.join("、") : "-"
}

export function buildProjectQueryPayload(filters = {}) {
  const payload = {}
  const name = (filters.name || "").trim()
  if (name) payload.name = name
  if (filters.topDepartmentId !== null && filters.topDepartmentId !== undefined && filters.topDepartmentId !== "") {
    const n = Number(filters.topDepartmentId)
    if (Number.isFinite(n)) payload.topDepartmentId = n
  }
  if (filters.validOnly === true || filters.validOnly === false) {
    payload.validOnly = filters.validOnly
  }
  return payload
}
